import React from 'react';
import { MobileStepper } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    // maxWidth: 200,
    // width: "100%",
    flexGrow: 1,
    background: 'transparent',
    direction: 'rtl',

    transform: 'rotate(180deg)',

    '& .MuiMobileStepper-progress': {
      width: '100%',
      borderRadius: 4,
      height: 8
    },

    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.secondary
    },

    '& .MuiMobileStepper-dots': {
      width: '100%',
      justifyContent: 'end'
    },

    '& .MuiMobileStepper-dot': {
      width: '20px',
      borderRadius: 16
    }
  }
}));

const StyledMobileStepper = withStyles({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  progress: {
    width: '90%'
  }
})(MobileStepper);

const StepperIndicator = ({ steps, currentStep }) => {
  const classes = useStyles();

  return (
    <StyledMobileStepper
      variant="progress"
      steps={steps}
      position="static"
      activeStep={currentStep}
      className={classes.root}
      nextButton={null}
      backButton={null}
      dir="ltr"
      on
      LinearProgressProps={{}}
    >
      <div>
        {currentStep + 1} of {steps}
      </div>
    </StyledMobileStepper>
  );
};

StepperIndicator.propTypes = {
  steps: PropTypes.number,
  currentStep: PropTypes.number,
  showCurrentStep: PropTypes.bool
};

export default StepperIndicator;
